import React from "react";
import './MobileNavStyle.css'
import { Link } from "react-router-dom";

const MobileNav = ()=>{
    const fun = ()=>{
        const element = document.getElementById("tooglemenu");
        if(element.checked == true){
            element.checked = false
        }
    }
    return <>
	<input type="checkbox" id="tooglemenu" />
	<label for="tooglemenu" class="toogleopen">
        <span className="spinner s1"></span>
        <span className="spinner s2"></span>
        <span className="spinner s3"></span>
    </label>
	<nav id="mobilemenu" onClick={fun}>		
		<ul>
            <Link to="/" exact><li>Home</li></Link>
            <Link to="/SpinCoin" exact><li>Coin Flip</li></Link>  
            <Link to="/RoadMap" exact><li>Roadmap</li></Link>
            <Link to="/Raffles" exact><li>Raffles</li></Link>
            <Link to="/Auctions" exact><li>Auctions</li></Link>
            <Link to="/Staking" exact><li>Staking</li></Link>
            <Link to="/MyateryBoxes" exact><li>Mystery Boxes</li></Link>  
		</ul>
	</nav>
</>
}

export default MobileNav